import React, { useMemo } from 'react';
import '../components-css/footer.scss';
import '../components-css/sales.scss';
import MiniHeaders from "./mini-headers";
import ImageCarousel from "./image-carousel";

const Sales = () => {
    const salesImagesNamesList = useMemo(() => {
        const list = [];
        for (let i = 1; i < 21; i++) {
            list.push(`sales-image-${i}`);
        }
        return list;
    }, []);

    return (
        <div>
            <div className="wrapper blocks-wrapper">
                <MiniHeaders headerName="Վաճառքներ" />
                <div>
                    <ImageCarousel items={salesImagesNamesList} />
                </div>
            </div>
        </div>
    );
};

export default Sales;
